<template>
  <!-- 抽奖 -->
  <answer-reward v-if="isLottery&& hasReward" />
  <!-- 正常红包 -->
  <end-award v-else-if="!isQuality&& hasReward" />
</template>

<script>
import AnswerReward from './AnswerReward.vue'
import EndAward from '../end/EndAward.vue'
import { AnswerStatus } from 'dygc'

export default {
  name: 'AwardAnswerWrapper',
  components: { AnswerReward, EndAward },
  data() {
    return {
    }
  },
  computed: {
    isLottery(){
      const currentAwardData = this.$bus.currentAwardData || {}
      return currentAwardData.awardIsLottery && currentAwardData.bindAward?.lotteryCategory !== 4
    },
    currentUserHasReward() {
      const data = this.$bus.currentAwardData || {}
      return !data.awardYuanAmount && !data.bindAward
    },
    hasReward() {
      const data = this.$bus.currentAwardData || {}
      return data.hasReward || ((this.$bus.lottery.lotteryAwards || []).length && !this.$bus.lottery.lotteryExpired)
    },
    isQuality() {
      return this.$bus.overData.status === AnswerStatus.QUALITY
    }
  }
}
</script>

<style scoped>

</style>